export default function validateUSMobileNumber(phoneNumber) {
  const usPhoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  return usPhoneRegex.test(phoneNumber);
}
